// Selectors


import { RootState } from '../../store';

export const organizationSelector = (state: RootState) => state.organizationState;
